import { format, isValid, parseISO } from 'date-fns';

export function formatDate(date: string | Date, formatStr: string = 'PPP'): string {
  const d = typeof date === 'string' ? parseISO(date) : date;
  return isValid(d) ? format(d, formatStr) : '';
}

export function formatTime(date: string | Date): string {
  const d = typeof date === 'string' ? parseISO(date) : date;
  return isValid(d) ? format(d, 'HH:mm') : '';
}

export function formatDateTime(date: string | Date): string {
  const d = typeof date === 'string' ? parseISO(date) : date;
  return isValid(d) ? format(d, 'PPP HH:mm') : '';
}

export function formatNaira(amount: number): string {
  return new Intl.NumberFormat('en-NG', {
    style: 'currency',
    currency: 'NGN',
    minimumFractionDigits: 0,
  }).format(amount);
}

export function formatMinutes(minutes: number): string {
  if (minutes < 60) {
    return `${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`;
  }
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  const hourStr = `${hours} ${hours === 1 ? 'hour' : 'hours'}`;
  const minStr = mins > 0 ? ` ${mins} ${mins === 1 ? 'minute' : 'minutes'}` : '';
  return `${hourStr}${minStr}`;
}

export function formatPercentage(value: number, decimals: number = 1): string {
  return `${value.toFixed(decimals)}%`;
}

export function getInitials(firstName: string, lastName: string): string {
  return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
}

export function capitalizeFirst(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export function formatStatus(status: string): string {
  return status
    .split('_')
    .map((word) => capitalizeFirst(word))
    .join(' ');
}

export function getLateStatusColor(lateCategory: string): string {
  switch (lateCategory) {
    case 'on_time':
      return 'green';
    case 'within_grace':
      return 'blue';
    case 'late':
      return 'orange';
    case 'very_late':
      return 'red';
    default:
      return 'default';
  }
}

export function getAccountStatusColor(status: string): string {
  switch (status) {
    case 'active':
      return 'green';
    case 'pending_approval':
      return 'orange';
    case 'suspended':
      return 'red';
    case 'deactivated':
      return 'default';
    default:
      return 'default';
  }
}

export function formatEmployeeId(employeeId: number | string | undefined | null): string {
  if (employeeId === undefined || employeeId === null) {
    return 'NEO000';
  }
  const id = typeof employeeId === 'string' ? Number.parseInt(employeeId, 10) : employeeId;
  if (Number.isNaN(id)) {
    return 'NEO000';
  }
  return `NEO${String(id).padStart(3, '0')}`;
}
